import { Observable } from 'rxjs';

import { InjectionToken } from '@angular/core';
import { RdSAPLookupCodeDtoV0 } from '../rdsap/rdSAPLookupCodeDtoV0';
import { AvailableInputTypeV0 } from '../rdsap/availableInputTypeV0';
import { RdSAPDataSetDtoV0 } from '../rdsap/rdSAPDataSetDtoV0';
import { ActuatorHealth, ActuatorInfo, RdSAPAssessmentReportMimeTypes } from 'src/rdsap-api';
import { RdSAPAssessmentReport } from '../../../core-state/services/data/rdsap-survey-details-data.service';

// Define the injection token for the aggregated data service
export const AGGREGATED_DATA_SERVICE_TOKEN = new InjectionToken<IAggregatedDataService>('AGGREGATED_DATA_SERVICE');


export interface RdSAPDetailsRequest {
  quid: string;
  reportReferenceNumber: string;
  accept: RdSAPAssessmentReportMimeTypes;
}


// Define the interface for the aggregated data service
export interface IAggregatedDataService {
  rdSAPLookUpCodes$: Observable<RdSAPLookupCodeDtoV0[]>;
  loadRdSAPLookUpCodes(): void;
  rdSAPHealth$: Observable<ActuatorHealth[]>;
  loadRdSAPHealth(): void;
  rdSAPInfo$: Observable<ActuatorInfo[]>;
  loadRdSAPInfo(): void;
  inputTypes$: Observable<AvailableInputTypeV0[]>;
  loadInputTypes(): void;
  rdSAPDataSets$?: Observable<RdSAPDataSetDtoV0[]>;
  loadRdSAPDataSetsForAsset?(assetId: string): void;
  rdSAPDetails$: Observable<RdSAPAssessmentReport[]>;
  loadRdSAPDetailsForAsset(
    params: RdSAPDetailsRequest
  ): void;
}
